import WebsiteLogo from "./WebsiteLogo.svg"

export const Images = {
    WebsiteLogo
};
